<template>
  <div>
    <hr />
    <articles-teaser :limit="4" />
    <hr />

    <cards-list :items="items"></cards-list>
  </div>
</template>

<script>
import ArticlesTeaser from "./ArticlesTeaser";
import CardsList from "./CardsList";
import database from "../database.json";

let revDatabase = database.reverse().slice();

export default {
  name: "HomePage",
  components: { CardsList, ArticlesTeaser },
  data() {
    return {
      items: revDatabase,
      title: "NA CO CI TO? - pomysły na prezenty, dziwne gadżety!",
      description:
        "Prezent dla niego? Prezent dla niej? Prezent na dzień chłopaka? Poszukaj inspiracji na NA CO CI TO?",
      urlContent: "https://nacocito.pl",
    };
  },
  metaInfo() {
    return {
      meta: [
        // general
        { name: "description", content: this.description },

        // Schema.org for Google
        { itemprop: "name", content: this.title },
        { itemprop: "description", content: this.description },
        // { itemprop: "image", content: this.imageSrc },

        // twitter
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: this.title },
        { name: "twitter:description", content: this.description },
        // { name: "twitter:image:src", content: this.imageSrc },

        // Open Graph general (Facebook, Pinterest & Google+)
        { property: "og:title", content: this.title },
        { property: "og:description", content: this.description },
        // { property: "og:image", content: this.imageSrc },
        // { property: "og:image:url", content: this.imageSrc },
        // { property: "og:image:width", content: 650 * 2 },
        // { property: "og:image:height", content: 341 * 2 },

        { property: "og:image:alt", content: this.title },
        { property: "og:url", content: this.urlContent },
        { property: "og:locale", content: "pl_PL" },
        { property: "og:type", content: "link" },

        // Open Graph - Product (e-commerce)
        // { property: 'product:price:currency', content: 'PLN'},
        // { property: 'product:price:amount', content: '6337.16'},
        // { property: 'product:brand', content: 'United States Mint'},
      ],
      title: this.title,
      description: this.description,
    };
  },
};
</script>


